function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "social_icon",
  "data-name": "social icon",
  d: "M990.133,6039.1a3.706,3.706,0,1,1-3.024-3.049A3.723,3.723,0,0,1,990.133,6039.1Zm2.8,8.97-.02-.07a10.367,10.367,0,0,0-2.576-4.49.379.379,0,0,0-.542.007,4.574,4.574,0,0,1-4.084,1.361,4.505,4.505,0,0,1-2.557-1.362.376.376,0,0,0-.539,0,10.353,10.353,0,0,0-2.575,4.487l-.019.07a.741.741,0,0,0,.728.929h11.455A.741.741,0,0,0,992.937,6048.071Zm6.037,0-.02-.07a10.371,10.371,0,0,0-2.576-4.49.38.38,0,0,0-.542.007,4.542,4.542,0,0,1-2.875,1.4,12.941,12.941,0,0,1,1.583,3.551l.024.088a.892.892,0,0,1,.009.442h3.669A.741.741,0,0,0,998.974,6048.071Zm-2.757-8.97a3.688,3.688,0,0,0-4.842-2.9.566.566,0,0,0-.294.837,5.161,5.161,0,0,1,0,5.392.569.569,0,0,0,.3.839,3.324,3.324,0,0,0,.562.145A3.723,3.723,0,0,0,996.217,6039.1Z",
  transform: "translate(-980 -6036)",
  fill: "#ccc"
});

var SvgFooterPersons = function SvgFooterPersons(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFooterPersons, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/footer-persons.3aa72591.svg";
export { ForwardRef as ReactComponent };